import React, { useEffect, useState } from 'react';
import Layout from '@/components/layout/Layout';
import api from '@/lib/axios';
import { formatDateTime } from '@/lib/utils';

const TABS = [
  { key: 'cancellation', label: 'Kündigungen' },
  { key: 'withdrawal', label: 'Widerrufe' },
];

export default function ContractDeclarationsPage() {
  const [kind, setKind] = useState('cancellation');
  const [rows, setRows] = useState([]);

  useEffect(() => {
    let cancelled = false;
    api.get('/admin/declarations', { params: { kind } })
      .then((r) => { if (!cancelled) setRows(r.data || []); })
      .catch(() => { if (!cancelled) setRows([]); });
    return () => { cancelled = true; };
  }, [kind]);

  return (
    <Layout>
      <div className="p-6 md:p-8" data-testid="contract-declarations-page">
        <h1 className="text-2xl font-semibold text-slate-900">Kündigung und Widerruf</h1>
        <p className="text-slate-600 mt-1">Eingegangene Erklärungen. Der Vertrag endet erst nach der Bearbeitung im Büro.</p>
        <div className="flex gap-2 mt-4">
          {TABS.map((tab) => (
            <button
              key={tab.key}
              type="button"
              className={`px-3 py-1.5 rounded-md text-sm ${kind === tab.key ? 'bg-slate-900 text-white' : 'bg-white border border-slate-200'}`}
              onClick={() => setKind(tab.key)}
              data-testid={`contract-declarations-tab-${tab.key}`}
            >
              {tab.label}
            </button>
          ))}
        </div>
        <div className="mt-4 space-y-3">
          {rows.length === 0 && <p className="text-sm text-slate-500">Keine Eingänge.</p>}
          {rows.map((row) => (
            <article key={row.id} className="bg-white border border-slate-200 rounded-lg p-4" data-testid={`contract-declaration-${row.reference}`}>
              <div className="font-medium text-slate-900">{row.first_name} {row.last_name}</div>
              <div className="text-sm text-slate-600">
                Eingegangen {formatDateTime(row.received_at)} · {row.reference}
              </div>
              <div className="text-sm text-slate-700 mt-1">
                {row.street} {row.house_number}, {row.postal_code} {row.city}
              </div>
              <div className="text-sm text-slate-600">{row.email}{row.kassenzeichen ? ` · Kassenzeichen ${row.kassenzeichen}` : ''}</div>
              <div className="text-sm text-slate-800 mt-1">{row.subject}</div>
              {row.timing === 'next' && <div className="text-sm text-slate-600">Zum nächstmöglichen Zeitpunkt</div>}
              {row.timing === 'date' && row.requested_date && <div className="text-sm text-slate-600">Zum {row.requested_date}</div>}
              {row.notes && <div className="text-sm text-slate-600 mt-1 whitespace-pre-line">{row.notes}</div>}
            </article>
          ))}
        </div>
      </div>
    </Layout>
  );
}
